var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 41,
    viewBox: "0 0 152 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9073 24.4834L55.5322 26.6179V34.1783H53.9298V14.4797H55.5322V23.8658L61.9495 14.4797H63.811L57.9357 22.994L65.2977 34.1783H63.3765L56.8993 24.4834H56.9073Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.895 34.4869C70.89 34.4869 69.2957 34.1234 68.1118 33.3923C66.928 32.6613 66.3341 31.34 66.3341 29.4284V27.0946C66.3341 25.2416 66.9918 23.9946 68.3111 23.3574C68.9409 23.0407 69.7421 22.8805 70.7186 22.8805C71.6155 22.8805 72.5243 23.0251 73.441 23.3144C74.3578 23.6037 75.1311 23.9829 75.7609 24.452C75.7609 23.4238 75.4539 22.6029 74.8441 21.9931C74.2342 21.3832 73.0584 21.0783 71.3205 21.0783L71.4082 19.8704C73.2417 19.8704 74.593 20.1557 75.4619 20.7265C76.3308 21.2972 76.865 21.9774 77.0682 22.7632C77.2675 23.5489 77.3712 24.5614 77.3712 25.7967V34.1703C75.3065 34.3775 73.8197 34.4791 72.9029 34.4791L72.895 34.4869ZM73.2537 24.7373C72.3648 24.4754 71.5477 24.3425 70.8023 24.3425C68.8731 24.3425 67.9086 25.2885 67.9086 27.1806V29.6239C67.9086 30.8435 68.339 31.727 69.2 32.2782C70.061 32.8294 71.2807 33.107 72.8671 33.107C73.6882 33.107 74.6528 33.0327 75.7609 32.8802V25.6599C74.9756 25.3042 74.1426 24.9953 73.2537 24.7334V24.7373Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3123 24.5382C96.3123 23.4124 96.0094 22.5914 95.4115 22.0637C94.8096 21.5399 94.0324 21.2779 93.0757 21.2779C92.3304 21.2779 91.5013 21.4382 90.5845 21.7549L89.5243 22.2592C89.8471 22.8964 90.0105 23.6274 90.0105 24.4522V34.1745H88.4361V24.5343C88.4361 23.3928 88.1371 22.5641 87.5353 22.0481C86.9334 21.532 86.1442 21.274 85.1716 21.274C84.5817 21.274 83.9679 21.3639 83.3381 21.5399C82.7083 21.7197 82.1343 21.9464 81.6201 22.2279V34.1705H80.0138V20.0935H81.6201L81.4766 20.9926C82.7362 20.2615 84.0276 19.898 85.347 19.898C86.0366 19.898 86.6783 20.0114 87.2802 20.2342C87.882 20.457 88.3922 20.7854 88.8148 21.2193C89.0818 21.0708 89.4844 20.8636 90.0185 20.6017C91.1465 20.0974 92.2347 19.8433 93.283 19.8433C94.6382 19.8433 95.7463 20.2498 96.6073 21.0668C97.4643 21.88 97.8987 23.0097 97.8987 24.4522V34.1745H96.3243V24.5343L96.3123 24.5382Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.781 32.7437C109.322 33.3067 108.744 33.7367 108.047 34.0377C107.349 34.3387 106.648 34.4872 105.942 34.4872C102.351 34.4872 100.553 32.775 100.553 29.3466V20.1013H102.16V29.5421C102.16 30.7422 102.498 31.6296 103.176 32.2121C103.854 32.7945 104.774 33.0838 105.942 33.0838C107.11 33.0838 107.991 32.7985 108.649 32.2277C109.306 31.657 109.637 30.7618 109.637 29.546V20.1052H111.24V34.1823H109.665L109.781 32.7476V32.7437Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.564 24.538C123.564 23.3965 123.225 22.5677 122.548 22.0517C121.87 21.5357 120.997 21.2777 119.925 21.2777C119.275 21.2777 118.618 21.3676 117.948 21.5435C117.278 21.7233 116.688 21.9501 116.17 22.2315V34.1742H114.564V20.0971H116.17L116.055 21.0509C116.513 20.6561 117.095 20.3629 117.801 20.1675C118.506 19.972 119.243 19.8743 120.009 19.8743C121.057 19.8743 121.958 20.0424 122.703 20.3786C123.469 20.7147 124.062 21.2229 124.493 21.8953C124.923 22.5716 125.139 23.4238 125.139 24.452V34.1742H123.564V24.5341V24.538Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.455 15.8127C128.256 15.6173 128.156 15.3944 128.156 15.1521C128.156 14.9097 128.252 14.6947 128.443 14.5071C128.634 14.3194 128.862 14.2256 129.133 14.2256C129.404 14.2256 129.623 14.3155 129.806 14.4914C129.99 14.6712 130.077 14.8902 130.077 15.1521C130.077 15.414 129.982 15.6407 129.79 15.8284C129.599 16.016 129.38 16.1098 129.133 16.1098C128.885 16.1098 128.658 16.0121 128.459 15.8127H128.455ZM128.296 20.0972H129.902V34.1743H128.296V20.0972Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.924 33.1071C133.445 32.4504 133.206 31.5708 133.206 30.4645V14.5032H134.809V20.0973H138.248L137.559 21.5867H134.809V30.4684C134.809 31.9656 135.438 32.9234 136.702 33.3339L136.243 34.5418C135.175 34.2408 134.402 33.7639 133.924 33.1071Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.194 35.949V32.8021C148.831 33.4002 148.285 33.838 147.56 34.1077C146.834 34.3775 146.049 34.5143 145.212 34.5143C143.53 34.5143 142.238 34.0687 141.33 33.1813C140.421 32.29 139.966 30.9765 139.966 29.233V20.101H141.513V29.5144C141.513 30.7145 141.848 31.6098 142.517 32.1961C143.187 32.7864 144.084 33.0796 145.212 33.0796C146.396 33.0796 147.352 32.7903 148.078 32.2079C148.803 31.6254 149.166 30.7263 149.166 29.5105V23.9751C149.166 23.0759 149.194 22.4075 149.25 21.9657C149.305 21.524 149.485 21.1135 149.78 20.7304C150.075 20.3473 150.569 20.0502 151.255 19.8469L151.685 20.9141C151.035 21.1956 150.713 21.8524 150.713 22.8805V35.8903C150.713 37.0318 150.481 37.931 150.023 38.5877C149.565 39.2445 148.791 39.7409 147.703 40.0771L147.273 38.8692C148.552 38.4001 149.194 37.4267 149.194 35.9451V35.949Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4728 36.3521H56.3851V38.3418C56.3851 38.678 56.3054 38.897 56.1898 39.0181C56.0623 39.1471 55.8909 39.2136 55.6238 39.2175C55.3607 39.2175 55.1854 39.1471 55.0618 39.0181C54.9422 38.9009 54.8665 38.6819 54.8665 38.3418V36.3521H54.0533V38.3614C54.0533 38.8579 54.1889 39.2644 54.4759 39.5498C54.7589 39.8273 55.1495 39.9642 55.6118 39.9642H55.6158H55.6238C56.0902 39.9642 56.4848 39.8273 56.7638 39.5498C57.0508 39.2683 57.1823 38.8618 57.1823 38.3731V36.356H56.4728V36.3521Z",
    fill: "#0C89EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3955 36.3521H61.3078V36.4381V38.4552L59.5819 36.3521H59.1116H59.0279H58.9402V39.9251H59.1116H59.5859H59.6696H59.7533V37.818L61.4832 39.9251H61.9536H62.0333H62.121V36.3521H61.4792H61.3955Z",
    fill: "#0C89EF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4527 39.1195C64.365 39.0334 64.2454 38.9826 64.1179 38.9865H64.1139C63.9903 38.9865 63.8707 39.0334 63.7791 39.1195C63.6834 39.2094 63.6316 39.3345 63.6316 39.4635V39.4713C63.6316 39.6003 63.6794 39.7254 63.7791 39.8153C63.8707 39.9013 63.9903 39.9521 64.1179 39.9521C64.2454 39.9521 64.365 39.9013 64.4527 39.8114C64.5444 39.7215 64.5922 39.5964 64.5922 39.4713V39.4635C64.5922 39.3345 64.5444 39.2133 64.4487 39.1234L64.4527 39.1195Z",
    fill: "#0C89EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1083 37.6421C69.1083 37.3841 69.0445 37.1495 68.917 36.9502C68.7894 36.7508 68.6021 36.5983 68.3709 36.5006C68.1397 36.399 67.8687 36.3521 67.5618 36.3521H66.1029V39.9251H66.916V38.9439H67.5618C67.8687 38.9439 68.1397 38.897 68.3709 38.7914C68.6021 38.6898 68.7854 38.5373 68.917 38.3418C69.0445 38.1503 69.1043 37.9196 69.1083 37.6695V37.6616V37.6499V37.6421ZM66.916 37.0909H67.5498C67.8288 37.0909 68.0162 37.1495 68.1278 37.2434C68.2434 37.3372 68.2952 37.4544 68.2992 37.6499C68.2992 37.8454 68.2434 37.9626 68.1278 38.0565C68.0162 38.1464 67.8288 38.2089 67.5498 38.2089H66.916V37.0909Z",
    fill: "#0C89EF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4082 38.4748H73.0624V37.9157V37.8336V37.7476H71.4082V37.087H73.2657V36.5201V36.4381V36.3521H70.5951V39.9251H73.3334V39.3543V39.2722V39.1862H71.4082V38.4748Z",
    fill: "#0C89EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6981 38.3418C77.8296 38.1425 77.8894 37.9079 77.8894 37.6499C77.8894 37.3919 77.8296 37.1534 77.6981 36.9541C77.5706 36.7547 77.3832 36.6022 77.152 36.5045C76.9209 36.4029 76.6498 36.356 76.3429 36.356H74.884V39.929H75.6972V38.9439H76.3429C76.3907 38.9439 76.4266 38.9399 76.4625 38.9321L77.172 39.9251H78.1047L77.2437 38.7367C77.4271 38.6389 77.5865 38.5138 77.6941 38.3457L77.6981 38.3418ZM75.6972 37.087H76.3269C76.606 37.087 76.7933 37.1456 76.9049 37.2394C77.0205 37.3333 77.0723 37.4505 77.0763 37.646C77.0763 37.8415 77.0205 37.9587 76.9049 38.0565C76.7933 38.1503 76.606 38.2089 76.3269 38.2089H75.6972V37.087Z",
    fill: "#0C89EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5444 38.0526C81.4128 37.9822 81.2693 37.9236 81.1179 37.8806C80.9704 37.8415 80.8269 37.8024 80.6834 37.7711C80.5479 37.7399 80.4243 37.7047 80.3127 37.6656C80.2131 37.6304 80.1373 37.5874 80.0855 37.5405C80.0457 37.5014 80.0297 37.4701 80.0297 37.388C80.0297 37.3255 80.0457 37.2786 80.0815 37.2238C80.1094 37.1808 80.1692 37.1378 80.2649 37.0987C80.3566 37.0636 80.4881 37.0401 80.6595 37.0401C80.791 37.0401 80.9266 37.0596 81.074 37.0948C81.2135 37.13 81.3451 37.1887 81.4726 37.2747L81.5563 37.3294L81.644 37.388L81.8792 36.829L81.9031 36.7665L81.931 36.7039L81.8154 36.6257C81.66 36.5202 81.4766 36.442 81.2733 36.3912C81.0701 36.3364 80.8668 36.313 80.6595 36.313C80.3526 36.313 80.0935 36.356 79.8743 36.4576C79.663 36.5515 79.4956 36.6844 79.388 36.8564C79.2804 37.0206 79.2285 37.2082 79.2285 37.4076C79.2285 37.603 79.2684 37.7789 79.3641 37.9197C79.4518 38.0526 79.5674 38.1581 79.7108 38.2363C79.8384 38.3067 79.9819 38.3653 80.1373 38.4122C80.2848 38.4552 80.4323 38.4904 80.5758 38.5256C80.7113 38.5569 80.8349 38.5882 80.9425 38.6272C81.0421 38.6624 81.1179 38.7054 81.1697 38.7562C81.2096 38.7953 81.2255 38.8266 81.2255 38.9048C81.2255 38.9673 81.2096 39.0103 81.1737 39.0612C81.1418 39.1042 81.086 39.1472 80.9863 39.1824C80.8947 39.2175 80.7552 39.2371 80.5798 39.2371C80.3885 39.2371 80.2051 39.2058 80.0297 39.1394C79.8504 39.0729 79.7108 38.9947 79.6032 38.9009L79.5195 38.8305L79.4318 38.7562L79.1608 39.3153L79.1329 39.37L79.105 39.4286L79.1967 39.5107C79.3521 39.6515 79.5554 39.7609 79.8025 39.8391C80.0496 39.9212 80.3087 39.9603 80.5798 39.9603C80.8867 39.9603 81.1498 39.9173 81.369 39.8196C81.5803 39.7257 81.7516 39.5928 81.8633 39.4208C81.9709 39.2566 82.0267 39.069 82.0267 38.8735C82.0267 38.682 81.9868 38.5061 81.8912 38.3653C81.8035 38.2363 81.6879 38.1308 81.5444 38.0526Z",
    fill: "#0C89EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0849 38.1347C87.0849 37.8767 87.037 37.6343 86.9414 37.4115C86.8457 37.1926 86.7102 36.9971 86.5348 36.8329C86.3594 36.6687 86.1562 36.5397 85.921 36.4498C85.6858 36.3599 85.4347 36.3169 85.1636 36.3169C84.8926 36.3169 84.6335 36.3638 84.3983 36.4537C84.1672 36.5436 83.9599 36.6726 83.7845 36.8368C83.6131 37.001 83.4736 37.1965 83.3779 37.4154C83.2783 37.6343 83.2305 37.8767 83.2305 38.1347V38.1386C83.2305 38.3966 83.2783 38.6351 83.3779 38.8579C83.4736 39.0768 83.6091 39.2723 83.7845 39.4364C83.9599 39.6006 84.1672 39.7296 84.3983 39.8196C84.6335 39.9095 84.8886 39.9564 85.1597 39.9564C85.4307 39.9564 85.6818 39.9134 85.917 39.8235C86.1482 39.7336 86.3554 39.6045 86.5308 39.4404C86.7062 39.2762 86.8417 39.0807 86.9374 38.8618C87.0331 38.6429 87.0769 38.4044 87.0809 38.1503V38.1425V38.1347V38.1308L87.0849 38.1347ZM85.1636 39.2175C84.9962 39.2175 84.8488 39.1902 84.7172 39.1354C84.5817 39.0807 84.4661 39.0064 84.3665 38.9087C84.2668 38.811 84.1911 38.7015 84.1313 38.5686C84.0755 38.4396 84.0476 38.2989 84.0476 38.1386C84.0476 37.9783 84.0755 37.8376 84.1313 37.7086C84.1871 37.5757 84.2628 37.4662 84.3665 37.3685C84.4661 37.2707 84.5817 37.1965 84.7172 37.1417C84.8527 37.087 85.0002 37.0596 85.1636 37.0596C85.3271 37.0596 85.4706 37.087 85.6061 37.1417C85.7416 37.1965 85.8572 37.2707 85.9529 37.3646C86.0525 37.4623 86.1283 37.5757 86.1841 37.7047C86.2399 37.8337 86.2678 37.9744 86.2678 38.1347C86.2678 38.295 86.2399 38.4357 86.1841 38.5647C86.1283 38.6976 86.0525 38.811 85.9529 38.9048C85.8532 39.0025 85.7376 39.0768 85.6061 39.1276C85.4706 39.1823 85.3271 39.2097 85.1636 39.2097V39.2175Z",
    fill: "#0C89EF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0549 36.3521H90.9673V36.4381V38.4552L89.2374 36.3521H88.771H88.6873H88.5996V39.9251H88.771H89.2413H89.325H89.4127V37.818L91.1387 39.9251H91.609H91.6927H91.7804V36.3521H91.1387H91.0549Z",
    fill: "#0C89EF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7259 36.3521H94.6143L92.9641 39.9251H93.8251L94.1878 39.1159H95.7184L96.0811 39.9251H96.9501L95.2959 36.3521H94.7179H94.7259ZM94.9571 37.4036L95.4075 38.4083H94.5067L94.9571 37.4036Z",
    fill: "#0C89EF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.955 36.3521H98.8673H98.3132H98.2295H98.1418V39.9251H98.3132H100.745V39.3543V39.2722V39.1862H98.955V36.3521Z",
    fill: "#0C89EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M102.164 36.3521H102.076V36.4381V39.9251H102.247H102.718H102.801H102.889V36.3521H102.247H102.164Z",
    fill: "#0C89EF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.417 36.8915V36.8642V36.5201V36.4381V36.3521H104.412V36.9228V37.0049V37.087H106.265L104.38 39.3817V39.757V39.8391V39.9251H104.547H107.477V39.3543V39.2722V39.1862H105.536L107.417 36.8915Z",
    fill: "#0C89EF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M109.713 38.4748H111.367V37.9157V37.8336V37.7476H109.713V37.087H111.57V36.5201V36.4381V36.3521H108.9V39.9251H111.638V39.3543V39.2722V39.1862H109.713V38.4748Z",
    fill: "#0C89EF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.588 39.9251H115.676H116.23H116.314H116.402V39.757V38.6155H118.06V38.0487V37.9666V37.8845H116.402V37.087H118.259V36.5201V36.4381V36.3521H115.588V39.9251Z",
    fill: "#0C89EF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.801 36.3521H119.714V36.4381V39.9251H119.885H120.355H120.439H120.527V36.3521H119.885H119.801Z",
    fill: "#0C89EF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.764 36.3521H124.676V36.4381V38.4552L122.946 36.3521H122.48H122.396H122.309V39.9251H122.48H122.95H123.034H123.122V37.818L124.852 39.9251H125.318H125.402H125.489V36.3521H124.848H124.764Z",
    fill: "#0C89EF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M128.435 36.3521H128.323L126.673 39.9251H127.534L127.897 39.1159H129.428L129.79 39.9251H130.659L129.005 36.3521H128.427H128.435ZM128.666 37.4036L129.117 38.4083H128.216L128.666 37.4036Z",
    fill: "#0C89EF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.306 36.3521H134.219V36.4381V38.4552L132.493 36.3521H132.022H131.943H131.855V39.9251H132.022H132.497H132.58H132.664V37.818L134.394 39.9251H134.864H134.948H135.032V36.3521H134.39H134.306Z",
    fill: "#0C89EF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M139.472 38.8149L139.408 38.7563L139.289 38.8813C139.177 38.9986 139.058 39.0807 138.922 39.1354C138.787 39.1902 138.639 39.2175 138.484 39.2175C138.316 39.2175 138.169 39.1902 138.029 39.1354C137.89 39.0807 137.77 39.0064 137.671 38.9126C137.571 38.8188 137.495 38.7054 137.439 38.5725C137.384 38.4435 137.356 38.2989 137.356 38.1386C137.356 37.9783 137.384 37.8376 137.439 37.7047C137.495 37.5718 137.571 37.4584 137.671 37.3646C137.77 37.2708 137.89 37.1965 138.029 37.1417C138.165 37.087 138.316 37.0597 138.484 37.0597C138.643 37.0597 138.787 37.087 138.922 37.1417C139.058 37.1965 139.177 37.2786 139.289 37.3919L139.349 37.4506L139.408 37.5131L139.839 37.1066L139.895 37.0518L139.954 36.9932L139.847 36.872C139.679 36.6883 139.472 36.5436 139.233 36.4498C138.994 36.356 138.739 36.3091 138.464 36.3091C138.189 36.3091 137.942 36.3521 137.706 36.442C137.475 36.5319 137.268 36.6609 137.097 36.8251C136.925 36.9893 136.786 37.1847 136.69 37.4037C136.59 37.6265 136.542 37.8728 136.542 38.1308C136.542 38.3888 136.59 38.6351 136.69 38.8579C136.786 39.0768 136.921 39.2723 137.093 39.4365C137.264 39.6006 137.467 39.7296 137.702 39.8196C137.938 39.9095 138.189 39.9525 138.46 39.9525C138.735 39.9525 138.998 39.9056 139.233 39.8117C139.472 39.7179 139.679 39.5733 139.847 39.3895L139.899 39.3309L139.954 39.2684L139.532 38.8657L139.472 38.8071V38.8149Z",
    fill: "#0C89EF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M142.167 39.1862V38.4748H143.825V37.9157V37.8336V37.7476H142.167V37.087H144.028V36.5201V36.4381V36.3521H141.357V39.9251H144.092V39.3543V39.2722V39.1862H142.167Z",
    fill: "#0C89EF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0725 39.4751C27.0725 39.4751 34.2233 29.577 49.3778 30.1986C45.9898 27.7514 41.2983 26.9109 34.5222 28.2635C33.0714 27.3487 36.6308 19.499 36.6308 19.499C36.6308 19.499 27.4831 27.0946 27.0725 39.4751Z",
    fill: "url(#paint0_linear_13_3911)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2665 23.8106C41.2665 25.2883 40.0428 26.4884 38.5362 26.4884C37.0295 26.4884 35.8058 25.2883 35.8058 23.8106C35.8058 22.3329 37.0295 21.1328 38.5362 21.1328C40.0428 21.1328 41.2665 22.3329 41.2665 23.8106Z",
    fill: "url(#paint1_linear_13_3911)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8625 39.7569C16.1112 34.6945 10.7501 32.8689 7.25047 32.8689C10.0048 34.9369 11.8662 36.7625 11.8662 36.7625C9.4826 37.3723 6.35364 41.0001 6.35364 41.0001C12.783 39.1002 18.2836 38.9321 20.8585 39.7569H20.8625Z",
    fill: "url(#paint2_linear_13_3911)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22745 36.1797C9.22745 37.071 8.49005 37.7942 7.58125 37.7942C6.67246 37.7942 5.93506 37.071 5.93506 36.1797C5.93506 35.2884 6.67246 34.5652 7.58125 34.5652C8.49005 34.5652 9.22745 35.2884 9.22745 36.1797Z",
    fill: "url(#paint3_linear_13_3911)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4958 36.7625C37.4958 36.7625 39.3572 34.9369 42.1115 32.8689C38.6118 32.8689 33.2508 34.6945 28.4995 39.7569C31.0744 38.9282 36.575 39.1002 43.0044 41.0001C43.0044 41.0001 39.8754 37.3723 37.4918 36.7625H37.4958Z",
    fill: "url(#paint4_linear_13_3911)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1344 36.1797C40.1344 37.071 40.8718 37.7942 41.7806 37.7942C42.6894 37.7942 43.4268 37.071 43.4268 36.1797C43.4268 35.2884 42.6894 34.5652 41.7806 34.5652C40.8718 34.5652 40.1344 35.2884 40.1344 36.1797Z",
    fill: "url(#paint5_linear_13_3911)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2934 39.4757C22.3093 32.2007 16.9801 21.3018 11.9658 19.0149C14.7958 22.8147 15.4415 27.3181 15.2422 27.8654C15.0429 28.4127 5.85934 25.9772 0 30.0193C5.21361 29.8747 13.7515 29.4603 22.2894 39.4757H22.2934Z",
    fill: "url(#paint6_linear_13_3911)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8667 23.8112C12.8667 25.1833 11.7347 26.2936 10.3356 26.2936C8.93657 26.2936 7.80457 25.1833 7.80457 23.8112C7.80457 22.4391 8.93657 21.3289 10.3356 21.3289C11.7347 21.3289 12.8667 22.4391 12.8667 23.8112Z",
    fill: "url(#paint7_linear_13_3911)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9685 39.4755C25.9685 39.4755 27.7063 20.2305 42.4025 13.6591C30.0899 15.5081 25.0278 23.1037 25.0278 23.1037C22.5445 20.9146 21.0299 15.7505 20.5954 11.8569C18.5227 24.9528 22.4449 34.0847 25.9724 39.4755H25.9685Z",
    fill: "url(#paint8_linear_13_3911)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6036 15.3553C29.6036 17.1809 28.0969 18.6586 26.2354 18.6586C24.374 18.6586 22.8673 17.1809 22.8673 15.3553C22.8673 13.5297 24.374 12.052 26.2354 12.052C28.0969 12.052 29.6036 13.5297 29.6036 15.3553Z",
    fill: "url(#paint9_linear_13_3911)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.435 15.1169L17.1675 4.63633L14.8237 4.49169L16.3145 2.84982L15.7923 0.437832L17.7654 1.3135L20.0174 0L19.7743 2.6309L21.5241 3.97958L19.1405 4.45651L18.435 15.1169Z",
    fill: "url(#paint10_linear_13_3911)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_3911",
    x1: 38.2252,
    y1: 42.0669,
    x2: 38.2252,
    y2: 1.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_3911",
    x1: 38.5362,
    y1: 42.0667,
    x2: 38.5362,
    y2: 1.80173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_3911",
    x1: 13.612,
    y1: 42.0673,
    x2: 13.612,
    y2: 1.80236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13_3911",
    x1: 7.58125,
    y1: 42.067,
    x2: 7.58125,
    y2: 1.80203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13_3911",
    x1: 35.7539,
    y1: 51.7387,
    x2: 35.7539,
    y2: -49.5647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13_3911",
    x1: 41.7846,
    y1: 42.0631,
    x2: 41.7846,
    y2: 1.80203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13_3911",
    x1: 11.1487,
    y1: 42.0675,
    x2: 11.1487,
    y2: 1.80261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13_3911",
    x1: 10.3356,
    y1: 42.0633,
    x2: 10.3356,
    y2: 1.80232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13_3911",
    x1: 31.21,
    y1: 42.0674,
    x2: 31.21,
    y2: 1.80243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13_3911",
    x1: 26.2354,
    y1: 42.067,
    x2: 26.2354,
    y2: 1.80204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_13_3911",
    x1: 18.1759,
    y1: 42.0671,
    x2: 18.1759,
    y2: 1.80215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF18F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BA1F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D67F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC548"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.718753a0daeafa77cbd71faa5ba85e8e.svg";
export { ForwardRef as ReactComponent };